// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('@rails/ujs').start();
require('turbolinks').start();
require('channels');

// TODO: process no longer supported, need to reimplment for react 18 upgrade
//
// const Sentry = require('@sentry/react');
// const Tracing = require('@sentry/tracing');
//
// if (process.env.CONFIG_SENTRY_ENABLED === 'true') {
//   Sentry.init({
//     dsn: process.env.CONFIG_SENTRY_DSN,
//     release: `oscar@${process.env.APP_RELEASE}`,
//     integrations: [new Tracing.Integrations.BrowserTracing()],
//     environment: process.env.CONFIG_SENTRY_ENVIRONMENT,
//     tracesSampleRate: 1.0,
//   });
// }

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
